/* 请求加密解密统一封装
 * @Author: zhouxuan
 * @Date: 2023-10-Tu 11:35:36
 * @Last Modified by:   zhoxuan
 * @Last Modified time: 2023-10-Tu 11:35:36
 */
import { encryptAes, decrypt, encryptHMAC } from "./crypto.js";
export const h5Id = "53acc12309844c12b3056f66305217e2";
export const oldTokenId = "7ef37b90507541f288740b9cc818a40c";
import http from "./http";

// 调试模式开关 - 控制调试日志输出和 VConsole 工具
const isDebugMode = import.meta.env.VITE_DEBUG_LOG === "true";

// 日志输出函数
const debugLog = (type, url, data) => {
  if (isDebugMode) {
    const timestamp = new Date().toLocaleString("zh-CN", {
      hour12: false,
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    console.log(`[${timestamp}] ${type} - ${url}`);
    console.log(data);
    console.log("═══════════════════════════════════════"); // 分隔线
  }
};

const pLength = new Array(100);

function canJSONParse(str) {
  if (typeof str == "string" && str.indexOf("{") != -1) {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log("error：" + str + "!!!" + e);
      return false;
    }
  } else {
    return false;
  }
}
/**
 * 请求方法
 * @param {*} url 请求地址
 * @param {*} params 请求的业务参数
 * @param {*} header 自定义数据 tokenId:加密解密的token noEncryption:无需加密 noDecryption:无需解密
 */
const post = (url = "", params = {}, header = {}) => {
  // UAT模式下记录未加密的业务入参
  debugLog("📤 POST请求 - 业务入参(未加密)", url, params);

  // 无需加密
  const noEncryption = header.noEncryption;
  // 无需解密
  const noDecryption = header.noDecryption;
  const tokenId = header?.tokenId ?? oldTokenId;
  let lastParam = params;
  if (!noEncryption) {
    const nonce = new Date().getTime() + "tcxy" + Math.random();
    const timestamp = new Date().getTime();
    const param = { ...params, nonce, timestamp };
    // 请求数据加密
    const requestParam = encryptAes(param, tokenId);
    const substr = requestParam.substring(0, pLength.length);
    const h5 = `h5Id=${h5Id}&`;
    const r = `requestParam=${substr}`;
    // 签名
    let signature = `${h5}${r}`;
    signature = encryptHMAC(signature, tokenId);
    lastParam = { requestParam, signature, h5Id };
  }
  // url = url + '?' + Object.entries(lastParam).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');

  return http.post(url, lastParam, { ...header, tokenId: null }).then((res) => {
    let data = res;
    // 数据解密处理
    if (res.data && !noDecryption) {
      const newData = decrypt(res.data, tokenId);
      let parseDa = {};
      if (canJSONParse(newData)) {
        parseDa = JSON.parse(newData);
      } else {
        parseDa = newData;
      }
      data = {
        data: parseDa,
        code: res.code,
        message: res.message,
      };
    }

    // UAT模式下记录业务出参（解密后的数据）
    debugLog("📥 POST响应 - 业务出参(已解密)", url, data);

    return data;
  });
};

/**
 * get请求特殊处理 参数拼接在url之上明文传输
 * @param {*} url
 * @param {*} params
 * @param {*} header
 * @returns
 */
const get = (url = "", params = {}, header = {}) => {
  // UAT模式下记录GET请求的业务入参
  debugLog("📤 GET请求 - 业务入参", url, params);

  const tokenId = header.tokenId ?? oldTokenId;
  const nonce = new Date().getTime() + "tcxy" + Math.random();
  const timestamp = new Date().getTime();
  const param = { ...params, nonce, timestamp };
  // 无需加密
  //   const noEncryption = header?.noEncryption;
  // 无需解密
  const noDecryption = header?.noDecryption;
  // 参数拼接
  let listUrl = "?";
  for (const key in param) {
    listUrl = listUrl + key + "=" + param[key] + "&";
  }
  listUrl = listUrl.slice(0, listUrl.length - 1);

  return http.get(url + listUrl, { ...header, tokenId: null }).then((res) => {
    // 数据解密处理
    if (res.data) {
      const newData = noDecryption ? res.data : decrypt(res.data, tokenId);
      res.data = noDecryption ? res.data : JSON.parse(newData);
    }

    // UAT模式下记录业务出参（解密后的数据）
    debugLog("📥 GET响应 - 业务出参(已解密)", url, res);

    return res;
  });
};

export default { post, get };
